// src/api/axiosConfig.js
import axios from 'axios';
import { supabase } from '../supabaseClient'; // Assuming supabaseClient is in src/

// process.env.REACT_APP_API_URL should be the ROOT URL, e.g., "http://localhost:8000"
const ROOT_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
console.log('axiosConfig.js: File Loaded, ROOT_API_URL:', ROOT_API_URL);

const apiClient = axios.create({
  baseURL: `${ROOT_API_URL}/api/v1`, // <<< CORRECTED BASE URL
  headers: {
    'Content-Type': 'application/json',
  },
});
console.log('axiosConfig.js: apiClient created with baseURL:', apiClient.defaults.baseURL);


// Request Interceptor
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();

      if (sessionError) {
        console.error('Error getting Supabase session for API client:', sessionError.message);
        return config;
      }

      if (session?.access_token) {
        config.headers['Authorization'] = `Bearer ${session.access_token}`;
      }
    } catch (error) {
      console.error('Error in Axios request interceptor:', error);
    }
    return config;
  },
  (error) => {
    console.error('Axios request interceptor error:', error);
    return Promise.reject(error);
  }
);
console.log('axiosConfig.js: Interceptor attached');

export default apiClient;